import React, {  useState, useEffect } from 'react';

import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import { useMeasure } from 'react-use';
import CommonDashboardWaitingAnswer from './common/CommonDashboardWaitingAnswer';
import { useParams } from 'react-router-dom';
import { getFormats } from '../../../helpers/helper_db';

const DashboardPage = () => {
	const [ref, { height }] = useMeasure<HTMLDivElement>();
	const { country } = useParams();
	const { format } = useParams();
	const [formats, setFormats] = useState([]);

	useEffect( () => {
        getFormats(country,format).then(p => {
            setFormats(p);
			console.log(p);
        });
    }, []);
	return (
		<PageWrapper title='Charts Page'>
			
			<Page container='fluid'>
				<div className='row'>
					{formats.map( ({ id, format, h_color, l_color,countryname, flag, css, url}) =>  
							<div className='col-xxl-12 col-xl-12'>
								<CommonDashboardWaitingAnswer country={country} format={id} countryname={countryname} format_name={format} flag={flag} hcolor={h_color} css={css} url={url} />
							</div>
						
					)}
				</div>
						
			</Page>
		</PageWrapper >
	);
};

export default DashboardPage;
